import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Layer, Attribute, MapPositionBounds } from "../../../types";
import { LayerPropertiesFlandersFeature } from "./LayerPropertiesFlandersFeature";

interface Props {
  layer: Layer;
  groupingKey: string | undefined;
  groupingCount: number | undefined;
  attributes: Attribute[];
  mapPosition: MapPositionBounds;
}

export function LayerPropertiesFlandersPrepare(props: Props) {
  const { attributes, layer, groupingKey, groupingCount, mapPosition } = props;

  const groupedAttributes = attributes.filter((attr) => attr.grouping);
  const singleAttributes = attributes.filter((attr) => !attr.grouping);

  return (
    <>
      {singleAttributes.length > 0 && (
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <LayerPropertiesFlandersFeature
              layer={layer}
              groupingKey={undefined}
              groupingCount={0}
              mapPosition={mapPosition}
              attributes={singleAttributes}
            />
          </Suspense>
        </ErrorBoundary>
      )}
      {groupedAttributes.length > 0 && (
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <LayerPropertiesFlandersFeature
              layer={layer}
              groupingKey={groupingKey}
              groupingCount={groupingCount}
              mapPosition={mapPosition}
              attributes={groupedAttributes}
            />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}
